import React, { PropTypes, Component } from 'react';
import FadeCarouselSide from '../../../shared-components/FadeCarouselSide';
import styles from './heroCarousel.scss';
import buttons from '../../../shared-styles/buttons.scss';

class HeroCarousel extends Component {
  state = {
    slideIndex: 0,
  }

  handleChange = (index) => {
    this.setState({
      slideIndex: index,
    });
  }

  render() {
    const ctaUrl = `${window.location.origin}${this.props.slides[this.state.slideIndex].ctaUrl}`;
    const extUrl = this.props.slides[this.state.slideIndex].extUrl;
    const link = extUrl || ctaUrl;
    const ctaCopy = this.props.slides[this.state.slideIndex].cta;

    return (
      <div className={styles.heroCarousel} >
        <FadeCarouselSide autoPlay={10000} slides={this.props.slides} onChange={this.handleChange} />
      </div>
    );
  }
}

HeroCarousel.propTypes = {
  slides: PropTypes.array,
};

export default HeroCarousel;



/** WEBPACK FOOTER **
 ** ./apps/homepage/components/HeroCarousel.js
 **/